// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__26eKb","dragIcon":"Choice_dragIcon__34byK","left":"Choice_left__2Xq2v","input":"Choice_input__36CAE"};